export const customDevPageBannerDataArabic = {
    mainHeading: "تطوير البرمجيات",
    mainHeadingGreenText: "المخصصة",
    subHeadingGreen: "موثوق به من قبل الشركات الناشئة والشركات الصغيرة والمتوسطة والمؤسسات في جميع أنحاء العالم",
    sectionDescripton: "دعنا نحول لحظة إلهامك من مفهوم أولي إلى تقييم جدوى، ومن تصميم إلى تطوير. تقدم خدماتنا لتطوير البرمجيات المخصصة حلولًا قوية وآمنة وقابلة للتطوير لضمان النمو المستدام لعملك.",
    bannerButtonText: "هيا بنا نبدأ"
}

export const CustomDevelopmentPageServicesDataArabic = {
    developmentServicesContent: {
        mainHeading: "مجموعتنا الواسعة من خدمات تطوير البرمجيات المخصصة الشاملة",
        sectionDescripton: "نحن ننشئ حلول برمجية تناسبك حقًا - سواء كان ذلك بناء منصات سحابية مخصصة، أو بوابات تفاعلية، أو صياغة أنظمة واجهة أمامية سلسة وأنظمة خلفية موثوقة. تم تصميم خدماتنا البرمجية المخصصة لتنمو مع عملك. من الاستشارات المتخصصة إلى تطوير التجارة الإلكترونية القابلة للتطوير، نقدم حلولًا آمنة ومرنة مصممة لتلبية احتياجاتك الفريدة."
    },
    developmentServicesTabs: [
        {
            id: "Tab1",
            label: "بوابات الويب التي تعمل من أجلك",
            content:
                "تعمل بوابات الويب كمركز رقمي مركزي للشركات، مما يوفر للموظفين والعملاء وأصحاب المصلحة وصولاً سلسًا إلى المعلومات والخدمات الأساسية. سواء كانت بوابة داخلية لتعاون الفريق، أو بوابة خدمة ذاتية للعملاء، أو نظام إدارة التجارة الإلكترونية، فإن بوابات الويب تحسن الكفاءة وتبسط العمليات.",
            secondContent: "يضمن تطوير بوابة الويب المخصصة ميزات مخصصة مثل الوصول المستند إلى الدور، ومشاركة البيانات في الوقت الفعلي، ولوحات المعلومات التفاعلية، والمصادقة الآمنة. من خلال تصميم يركز على المستخدم وتكامل سلس مع أدوات الطرف الثالث، تعزز بوابة الويب المصممة جيدًا المشاركة، وتحسن أتمتة سير العمل، وتحسن عمليات الأعمال لزيادة الإنتاجية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab2",
            label: "أنظمة خلفية قوية وآمنة",
            content:
                "تعد الواجهة الخلفية القوية والآمنة العمود الفقري لأي تطبيق رقمي، مما يضمن الوظائف السلسة وسلامة البيانات وموثوقية النظام. تتعامل أنظمة الواجهة الخلفية مع معالجة البيانات والمصادقة ومنطق الأعمال وعمليات جانب الخادم، مما يسمح للتطبيقات بالعمل بسلاسة دون انقطاع.",
            secondContent: "من خلال الاستفادة من تقنيات مثل FastAPI و GraphQL و Angular و MySQL، يمكن للشركات بناء حلول خلفية قابلة للتطوير وعالية الأداء. تضمن إجراءات الأمان مثل التشفير ومصادقة واجهة برمجة التطبيقات وتحسين قاعدة البيانات حماية البيانات والامتثال لمعايير الصناعة. تدعم بنية الواجهة الخلفية جيدة التنظيم النمو المستقبلي، مما يمكن الشركات من توسيع نطاق تطبيقاتها بسهولة.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab3",
            label: "تجارب واجهة أمامية سهلة الاستخدام",
            content:
                "تعد الواجهة الأمامية الجذابة بصريًا والبديهية ضرورية لإشراك المستخدمين وتقديم تجربة رقمية سلسة. يركز تطوير الواجهة الأمامية على إنشاء واجهات سهلة الاستخدام تعزز إمكانية الوصول والاستجابة وسهولة التنقل عبر الأجهزة.",
            secondContent: "من خلال اعتماد مبادئ UI/UX الحديثة، يمكن للشركات تطوير تصميمات جذابة بصريًا تزيد من قابلية الاستخدام. تساهم ميزات مثل العناصر التفاعلية والتحديثات في الوقت الفعلي والأداء المحسن في رضا العملاء. يضمن الاستفادة من أطر عمل مثل React أو Angular أو Vue.js أن تطبيقات الواجهة الأمامية ديناميكية وسريعة التحميل وتفاعلية للغاية، مما يحافظ على تفاعل المستخدمين ويحسن معدلات التحويل.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "استشارات برمجية ذكية",
            content:
                "تلعب استشارات البرمجيات دورًا حاسمًا في توجيه الشركات خلال التطورات التكنولوجية، مما يضمن اختيار الحلول المناسبة لاحتياجاتها الفريدة. يحلل المستشارون الخبراء سير العمل الحالي، ويحددون أوجه القصور، ويوصون بحلول برمجية مخصصة تعمل على تحسين العمليات.",
            secondContent: "تساعد استراتيجية البرمجيات المخططة جيدًا الشركات على تقليل التكاليف وتخفيف المخاطر وتعزيز الكفاءة. سواء كان ذلك الانتقال إلى الحلول المستندة إلى السحابة، أو تحسين بنية النظام، أو دمج أدوات الأتمتة، توفر استشارات البرمجيات الخبرة اللازمة لتنفيذ تحول رقمي فعال. من خلال نهج منظم، يمكن للشركات البقاء في صدارة المنافسة والاستفادة من التكنولوجيا لدفع النمو.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "برامج مخصصة للمؤسسات",
            content:
                "تم تصميم حلول برامج المؤسسات لتلبية احتياجات العمل المحددة، وتوفير الأتمتة وإدارة البيانات وتبسيط العمليات. على عكس الحلول الجاهزة، توفر البرامج المخصصة المرونة وقابلية التوسع والأمان لتلبية متطلبات العمليات واسعة النطاق.",
            secondContent: "تتيح تطبيقات المؤسسات المخصصة للشركات تحسين سير العمل، ودمج أنظمة متعددة، وضمان التواصل السلس عبر الأقسام. من أنظمة إدارة علاقات العملاء (CRM) إلى حلول تخطيط موارد المؤسسات (ERP)، تعزز البرامج المخصصة الإنتاجية، وتقلل من أوجه القصور التشغيلية، وتحسن عملية اتخاذ القرار من خلال التحليلات والتقارير في الوقت الفعلي.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "حلول CMS المرنة بلا رأس",
            content:
                "يفصل نظام إدارة المحتوى (CMS) بلا رأس إدارة المحتوى عن عرض الواجهة الأمامية، مما يمنح الشركات تحكمًا كاملاً في كيفية تسليم محتواها عبر منصات متعددة. هذه المرونة حاسمة للشركات التي تدير المحتوى عبر مواقع الويب وتطبيقات الهاتف المحمول وأجهزة إنترنت الأشياء والقنوات الرقمية الأخرى.",
            secondContent: "باستخدام نظام إدارة المحتوى بلا رأس، يمكن للشركات تبسيط توزيع المحتوى، مما يضمن الاتساق عبر الأنظمة الأساسية المختلفة مع تمكين التحديثات الأسرع وقابلية التوسع. يسمح للمطورين باستخدام واجهات برمجة التطبيقات (APIs) لجلب المحتوى ديناميكيًا، مما يوفر أداءً محسنًا وتجربة مستخدم سلسة. تعمل حلول CMS بلا رأس على تمكين منشئي المحتوى بأدوات سهلة الاستخدام مع توفير الحرية للمطورين لتصميم تجارب واجهة أمامية مخصصة.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
    ]
}

export const CustomDevPageTypesOfBuildDataArabic = {
    TypesOfBuildContent: {
        mainHeading: "نهج خطوة بخطوة لمشروع ناجح",
        sectionDescripton: "اكتشف حلول برمجية مخصصة، من التصميم إلى النشر، مصممة لتلبية احتياجات عملك الفريدة",
    },
    TypesOfBuildDataAccordian: [
        {
            id: "collapsenine",
            question: "خدمات التطوير",
            answer: {
                discription:
                    "نحن نصمم حلولًا برمجية تتماشى مع أهدافك، ونقدم خدمات مخصصة لكل شيء بدءًا من تصميم الواجهة الأمامية إلى تطوير الواجهة الخلفية وما بعدها.",
                listTitle: "",
                listContent: [],
            },
        },
        {
            id: "collapseOne",
            question: "جمع المتطلبات",
            answer: {
                discription:
                    "فهم احتياجاتك هو نقطة البداية. نعمل معك عن كثب لجمع كل التفاصيل، مما يضمن أن تطوير برامجنا المخصصة يلبي متطلباتك الدقيقة.",
                listTitle: "",
                listContent: [],
            },
        },
        {
            id: "collapseTwo",
            question: "التحليل والتخطيط",
            answer: {
                discription:
                    "التخطيط يجعل كل شيء أفضل! نقوم بتحليل متطلباتك ووضع استراتيجية واضحة، مما يضمن أن برنامجك قابل للتطوير وفعال ومصمم بشكل مثالي.",
            },
        },
        {
            id: "collapseThree",
            question: "تصميم واجهة المستخدم / تجربة المستخدم",
            answer: {
                discription:
                    "التصميم ليس مجرد مظهر - إنه يتعلق بإنشاء التجارب. نحن نركز على التصميمات البديهية سهلة الاستخدام التي تجعل حلول برامجك جذابة وسهلة الاستخدام.",
            },
        },
        {
            id: "fourth",
            question: "التطوير",
            answer: {
                discription:
                    "هنا تتحول الأفكار إلى حقيقة! تركز عملية التطوير لدينا على بناء برامج موثوقة وقابلة للتطوير تعمل بسلاسة وتنمو مع عملك.",
            },
        },
        {
            id: "fifth",
            question: "ضمان الجودة والاختبار",
            answer: {
                discription:
                    "نحن نختبر كل شيء بدقة لضمان أن برنامجك خالٍ من الأخطاء ويعمل بشكل مثالي. ضمان الجودة هو كيف نقدم حلول برمجية موثوقة يمكنك الوثوق بها.",
            },
        },
        {
            id: "Sixth",
            question: "النشر",
            answer: {
                discription:
                    "عندما يصبح جاهزًا، نتأكد من أن كل شيء مهيأ لإطلاق سلس. من الفحوصات النهائية إلى النشر في الوقت الفعلي، نضمن أن برنامجك يعمل بشكل لا تشوبه شائبة.",
            },
        },
        {
            id: "seventh",
            question: "الصيانة والترقيات",
            answer: {
                discription:
                    "عملنا لا ينتهي عند التسليم. نحن نقدم دعمًا مستمرًا، وتحديثات منتظمة، وترقيات لضمان بقاء برنامجك حديثًا وفعالًا وجاهزًا للمستقبل.",
            },
        },
    ]
}

export const CustomDevPageWhoWeServeDataArabic = {
    whoWeServeContent: {
        mainHeading: "من نخدم",
        sectionDescripton: "نحن ننشئ خدمات برمجية مخصصة للشركات الناشئة وشركات المنتجات والمؤسسات عبر مختلف الصناعات."
    },

    WhoWeServeCards: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "الشركات الناشئة",
            description:
                "نحن نساعد الشركات الناشئة على تحويل أفكارها إلى حقيقة من خلال برامج قابلة للتطوير وحلول تطبيقات مخصصة مصممة لتنمو مع احتياجات أعمالهم.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "شركات المنتجات البرمجية",
            description:
                "تمكين شركات المنتجات بخدمات برمجية مخصصة، من التصميم إلى النشر، مما يضمن تجارب مستخدم سلسة وقابلية للتوسع.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "المؤسسات من 30+ صناعة",
            description:
                "تحويل المؤسسات من خلال تطوير البرمجيات المخصصة وحلول البرمجيات القابلة للتطوير عبر مختلف الصناعات والتحديات.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const CustomDevPageWhyChooseBitsclanDataArabic = {
    whyChoseBitsclanContent: {
        mainHeading: "لماذا تختار Bitsclan كشركة تطوير برمجيات مخصصة لك؟",
        sectionDescripton: "في Bitsclan، نقدم خدمات برمجية مخصصة مصممة لتلبية احتياجاتك الفريدة. من المواهب الخبيرة ومواءمة المنطقة الزمنية إلى الجودة وقابلية التوسع، يضمن تطوير البرمجيات المخصصة لدينا حلولاً سلسة للشركات من جميع الأحجام."
    },
    whyChoseBitsclanTabs: [
        {
            id: "Tab1",
            label: "الجودة لأنها مهمة",
            content:
                "في Bitsclan، الجودة ليست مجرد عملية - إنها جوهر كل ما نقوم به. نحن متخصصون في بناء حلول برمجية عالية الأداء وقابلة للتطوير وقوية مصممة خصيصًا لتلبية المتطلبات الفريدة لعملك.",
            content2:
                "من جلسات العصف الذهني الأولى إلى النشر النهائي وما بعده، نولي اهتمامًا دقيقًا بالتفاصيل وأفضل الممارسات الصناعية لضمان أن برنامجك فعال وآمن ومصمم لتحقيق نجاح طويل الأمد. نحن لا نلبي التوقعات فحسب - بل نتجاوزها باستمرار.",
            btnText: "تواصل مع القبيلة",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "أفضل المواهب من نوعها",
            content:
                "تكمن قوتنا في موظفينا. تجمع Bitsclan فريقًا من المطورين ذوي المهارات العالية، ومصممي واجهة المستخدم/تجربة المستخدم، ومهندسي البرمجيات، والمهندسين الذين يمتلكون معرفة تقنية عميقة وخبرة عبر الصناعات.",
            content2:
                "من الشركات الناشئة المبتكرة إلى أنظمة المؤسسات المعقدة، يقدم خبراؤنا حلولًا ذكية وقابلة للتطوير ومؤثرة باستخدام أحدث الأدوات والتقنيات والمنهجيات. يقود كل مشروع الإبداع والدقة وشغف حقيقي بالتكنولوجيا.",
            btnText: "تواصل مع القبيلة",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "محاذاة المنطقة الزمنية للتعاون السلس",
            content:
                "يتطلب العملاء العالميون استجابة في الوقت الفعلي - ونحن نقدمها. تعمل فرقنا الموزعة عالميًا بما يتماشى مع منطقتك الزمنية، مما يضمن التواصل السريع والتنسيق السلس في كل خطوة.",
            content2:
                "سواء كانت اجتماعات يومية، أو تحديثات للمشروع، أو تغييرات فورية، يتكيف سير عملنا مع جدولك الزمني، مما يزيل الاختناقات ويعزز زخم المشروع. نعمل كامتداد لفريقك، بغض النظر عن مكان وجودك في العالم.",
            btnText: "تواصل مع القبيلة",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "تكنولوجيا حديثة لحلول مقاومة للمستقبل",
            content:
                "في المشهد التكنولوجي سريع التطور اليوم، البقاء على اطلاع ليس خيارًا - إنه ضروري. يستكشف فريقنا باستمرار التقنيات الناشئة لضمان أن الحلول التي نبنيها ذات صلة اليوم وقابلة للتكيف مع المستقبل.",
            content2:
                "سواء كان ذلك تطويرًا سحابيًا أصيلًا، أو أتمتة مدفوعة بالذكاء الاصطناعي، أو تكامل blockchain، أو أطر عمل الواجهة الأمامية الحديثة، فإننا نطبق أحدث الأدوات والممارسات لتقديم برامج تعمل اليوم وتزدهر في المستقبل.",
            btnText: "تواصل مع القبيلة",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "الالتزام بالتميز",
            content:
                "نحن لا نبني برامج فقط - نحن نبني الثقة. في Bitsclan، يتم التعامل مع كل مشروع بشعور عميق بالملكية والمسؤولية والشغف بالتميز. تصبح أهدافك مهمتنا.",
            content2:
                "من جمع المتطلبات المتعمق والتنفيذ الرشيق إلى تحسين ما بعد النشر والدعم، نبذل قصارى جهدنا لضمان أن يكون حلك قويًا وموثوقًا ومتوافقًا مع استراتيجية عملك طويلة الأجل.",
            btnText: "تواصل مع القبيلة",
            btnLink: "#",
        },
    ]
}

export const customDevPageHighvaluesDataArabic = {
    highValueContent: {
        mainHeading: "ميزات عالية القيمة لحلول برامج مخصصة عالية الأداء",
        sectionDescripton: "يقدم تطوير البرامج المخصصة لدينا حلولًا عالية الأداء مصممة خصيصًا لاحتياجاتك. من فرق الخبراء إلى التصميمات القابلة للتطوير، نضمن الجودة والابتكار والتكامل السلس للارتقاء بنجاح عملك.",
        buttonText: "استشر نطاق المشروع"
    },
    highvaluesDataCards: [
        {
            image: "custom-app-development.svg",
            text: "تطوير تطبيقات مخصصة",
        },
        {
            image: "user-centric-designs.svg",
            text: "تصميمات تتمحور حول المستخدم",
        },
        {
            image: "robust-architecture.svg",
            text: "هندسة معمارية قوية",
        },
        {
            image: "efficient-integration.svg",
            text: "تكامل فعال",
        },
        {
            image: "advanced-analytics.svg",
            text: "تحليلات متقدمة",
        },
        {
            image: "enhanced-security.svg",
            text: "أمان معزز",
        },
        {
            image: "agile-methodology.svg",
            text: "منهجية Agile",
        },
        {
            image: "cross-platform-support.svg",
            text: "دعم متعدد المنصات",
        },
        {
            image: "ongoing-maintenance.svg",
            text: "صيانة مستمرة",
        },
        {
            image: "innovation-driven-features.svg",
            text: "ميزات مدفوعة بالابتكار",
        },
    ]
}

export const customDevelopmentPageRoadMapDataArabic = {
    roadMapStepsContent: {
        mainHeading: "خارطة طريقنا المثبتة لضمان نجاحك",
        sectionDescripton: "تضمن خارطة طريقنا النجاح في كل مرحلة من رحلة تطوير برامجك المخصصة. من التخطيط إلى الاختبار، نقدم خدمات برمجية مخصصة مصممة لتلبية أهدافك الفريدة بدقة وعناية."
    },
    roadMapStepsHeading: [
        "الاكتشاف والتخطيط",
        "التصميم وإثبات المفهوم",
        "التطوير والاختبار",
        "التنفيذ والدعم"
    ],
    roadMapStepsDescription: [
        "نحن نتماشى مع رؤيتك، وننشئ خارطة طريق تضمن التطوير الفعال، وقابلية التوسع، وحلول برمجية مخصصة تركز على الأعمال.",
        "حوّل الأفكار إلى واقع! نصمم نماذج وتصاميم أولية، مما يضمن الجدوى ومواءمة الحل مع احتياجاتك وتوقعاتك.",
        "يوفر تطويرنا القوي واختبارنا الصارم حلول تطبيقات مخصصة آمنة وموثوقة مع ضمان الأداء الأمثل وقابلية التوسع.",
        "نحن نركز على التنفيذ السلس ونقدم دعمًا مستمرًا، مما يضمن أن برنامجك القابل للتطوير يلبي الأهداف التشغيلية طويلة الأجل بسلاسة.",
    ]
}

export const customDevPageCoverTheStackArabic = {
    CoverTheStackContent: {
        mainHeading: "قم بتحسين حلول البرامج الخاصة بك باستخدام مجموعة التقنيات الرائدة في الصناعة",
        sectionDescription: "استفد من أحدث التقنيات لتطوير برامجك المخصصة. تضمن لك باقتنا التقنية المتطورة حلولاً برمجية قابلة للتطوير وآمنة وفعالة، مصممة خصيصاً لتلبية احتياجات عملك.",
        defaultTabOpen: "الواجهة الأمامية"
    },

    tabs: [
        "الواجهة الأمامية",
        "الواجهة الخلفية",
        "المكتبات",
        "قاعدة البيانات",
    ],

    tabItems: [
        { tab: "الواجهة الأمامية", icon: "/images/iconthree.png", name: "React JS" },
        { tab: "الواجهة الأمامية", icon: "/images/iconone.png", name: "Angular JS" },
        { tab: "الواجهة الأمامية", icon: "/images/icon7.png", name: "HTML5" },
        { tab: "الواجهة الأمامية", icon: "/images/icon6.png", name: "CSS3" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/gatsby.svg", name: "Gatsby" },
        { tab: "الواجهة الأمامية", icon: "/images/icon4.png", name: "Vue JS" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/ember.svg", name: "Ember.js" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/svelte.svg", name: "Svelte" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/backbone-js.svg", name: "Backbone.js" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/polymer.svg", name: "Polymer" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/aurelia.svg", name: "Aurelia" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/meteor.svg", name: "Meteor.js" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/next-js.svg", name: "Next.js" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/semantic.svg", name: "Semantic-UI" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/nuxt-js.svg", name: "Nuxt" },
        { tab: "الواجهة الخلفية", icon: "/images/database9.png", name: "Node Js" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/elixir.svg", name: "Elixir" },
        { tab: "الواجهة الخلفية", icon: "/images/database1.png", name: ".Net" },
        { tab: "الواجهة الخلفية", icon: "/images/database6.png", name: "Python" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/ruby_on_rails.svg", name: "Ruby On Rails" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/java.svg", name: "Java" },
        { tab: "الواجهة الخلفية", icon: "/images/database8.png", name: "PHP" },
        { tab: "الواجهة الخلفية", icon: "/images/django-tech.svg", name: "Django" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/golang.svg", name: "Go" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/c-sharp.svg", name: "C#" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/scala.svg", name: "Scala" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/rust.svg", name: "Rust" },
        { tab: "قاعدة البيانات", icon: "/images/db5.png", name: "MySQL" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/couchdb.svg", name: "Couch DB" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/indexed.svg", name: "Indexed DB" },
        { tab: "قاعدة البيانات", icon: "/images/db3.png", name: "MongoDB" },
        { tab: "قاعدة البيانات", icon: "/images/db7.png", name: "SQLite" },
        { tab: "قاعدة البيانات", icon: "/images/db6.png", name: "MS SQL Server" },
        { tab: "قاعدة البيانات", icon: "/images/db1.png", name: "Firebase" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/swift.svg", name: "Swift" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/redis.svg", name: "Redis" },
        { tab: "قاعدة البيانات", icon: "/images/db8.png", name: "DynamoDB" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/jquery.svg", name: "jQuery" },
        { tab: "المكتبات", icon: "/images/iconthree.png", name: "React" },
        { tab: "المكتبات", icon: "/images/iconone.png", name: "Angular" },
        { tab: "المكتبات", icon: "/images/icon4.png", name: "Vue.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/vue-x.svg", name: "Vue.x" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/rx-js.svg", name: "Rxjs" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/backbone-js.svg", name: "Backbone.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/ember.svg", name: "Ember.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/d3-js.svg", name: "D3.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/redux.svg", name: "Redux" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/lodash.svg", name: "Lodash" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/styled-component.svg", name: "Styled Component" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/emotion.svg", name: "Emotion" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/graphql.svg", name: "Graph QL" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/ant-design.svg", name: "Ant Design" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/inertia.svg", name: "Inertia.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/mobx.svg", name: "Mobx" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/web3.svg", name: "Web3" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/Web.svg", name: "WebGL" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/core-ui.svg", name: "Core UI" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/material-ui.svg", name: "Material UI" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/flow-js.svg", name: "Flow.js" },
    ]
}

export const CustomDevelopmentIndustriesHeadingArabic = {
    mainHeading: "الصناعات التي نخدمها في التطوير المخصص",
}

export const CustomDevPageFaqDataArabic = {
    faqContent: {
        mainHeading: "الأسئلة الشائعة",
        sectionDescription: "احصل على إجابات سريعة لأسئلتك حول عملية وخدمات تطوير تطبيقات الهاتف المحمول لدينا."
    },
    questionAndAnswer: [
        {
            id: "collapseOne",
            question: "كم تبلغ تكلفة تطوير برنامج مخصص؟",
            answer:
                "تختلف تكلفة تطوير البرامج المخصصة بناءً على عدد من العوامل، بما في ذلك المدة وتخصيص الفريق والاحتياجات. عادةً ما تتراوح التكلفة بين 15000 دولار و 300000 دولار. للحصول على تقدير دقيق.",
        },
        {
            id: "collapseTwo",
            question: "لماذا تستأجر شركة تطوير برمجيات مخصصة؟",
            answer:
                "إذا كنت تتطلع إلى تطوير برامج مخصصة مصممة خصيصًا لاحتياجاتك، فمن الأفضل الاستعانة بشركة تقدم خدمات تطوير برامج مخصصة.",
        },
        {
            id: "collapseThree",
            question: "كم من الوقت سيستغرق إكمال برنامجي المخصص؟",
            answer:
                "تعتمد المدة التي يستغرقها إكمال برنامج مخصص على عوامل مختلفة بما في ذلك تعقيد البرنامج، والهيكل، والمكدس التقني، والمزيد. لإعطائك فكرة، يمكن أن تتراوح المدة بين 4 و 20 شهرًا. للحصول على تقدير دقيق لمشروعك.",
        },
        {
            id: "fourth",
            question: "ماذا لو غيرت متطلبات المشروع خلال السبرنت؟",
            answer:
                "إذا قررت تغيير أولويات ومتطلبات المشروع خلال سبرنت جاري، فسنقوم بسرعة بتقييم التغييرات الجديدة، وإنشاء تقرير بناءً عليها، ووضع استراتيجية خطة جديدة، والبدء في تنفيذها بعد التأكيد مع أصحاب المصلحة الرئيسيين.",
        },
        {
            id: "fifth",
            question: "كيف تضمنون التعاون؟",
            answer:
                "فريقنا مصمم للعمل في منطقتك الزمنية القريبة من الشاطئ ونحن نستخدم أدوات تعاون مميزة لمنع أي سوء تفاهم وضمان تعاون سلس. يعقد مديرو المشاريع لدينا اجتماعات منتظمة مع فريقك لضمان التسليم في الوقت المناسب وبدقة.",
        },
        {
            id: "sixth",
            question:
                "كيف تتعاملون مع التأخيرات والصعوبات في التواصل مع أصحاب المصلحة في عملنا؟",
            answer:
                "نحن ندرك أن أصحاب المصلحة في الأعمال لديهم جداول زمنية ضيقة، لذلك نولي الأولوية للاجتماعات ذات الأجندات المناسبة. يأخذ فريقنا في الاعتبار كل ما يحتاج إلى مناقشة، ومع الأولويات الواضحة، نجعل الاجتماعات ذات قيمة. حقيقة أخرى هي أن معظم هذه الاجتماعات تكون ضرورية في مرحلة جمع المتطلبات، ومع تطور المشروع، تقل الحاجة إليها.",
        },
    ]
}